<template>
  <Products
    v-for="section in sections"
    :key="section.id"
    :section-id="section.id"
  />
</template>

<script setup>
import { ref, onMounted } from "vue";
import api from "@/plugins/axios";
import Products from "@/components/ListProducts.vue";

const sections = ref([]);
const loading = ref(false);
const errorMessage = ref("");

/*
|--------------------------------------------------------------------------
| دریافت بخش‌های صفحه اصلی
|--------------------------------------------------------------------------
*/
const getHomePageSections = async () => {
  loading.value = true;
  errorMessage.value = "";

  try {
    const response = await api.get("/general/home-page-Sections");

    if (response.data?.success) {
      sections.value = response.data.data || [];
    } else {
      sections.value = [];
      errorMessage.value =
        response.data?.message || "دریافت بخش‌ها با خطا مواجه شد.";
    }
  } catch (error) {
    console.error("Error fetching home page sections:", error);

    sections.value = [];
    errorMessage.value =
      error.response?.data?.message ||
      "خطا در ارتباط با سرور. لطفاً دوباره تلاش کنید.";
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  getHomePageSections();
});
</script>